var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navbar'),_c('router-view'),_c('footer-vue'),(!_vm.isAdminRoute)?_c('whatsapp-button'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }